import React, { FC } from "react";
import { Tooltip, Upload, Modal } from "antd";
import { ReactComponent as AddFileIcon } from "../../img/add-file.svg";
import { ReactComponent as XlsxFileIcon } from "../../img/xlsx-file.svg";
import { ReactComponent as DeleteFile } from "../../img/delete-file.svg";
import { UploadedTemplateFile } from "../../lib/interfaces/DocumentTemplate";

interface IProps {
  fileExists: boolean;
  fileChanged?: boolean;
  acceptedFileTypes: string[];
  setFile: (file: File | null) => void;
  fileChangedTitle?: string;
  style?: { [key: string]: string };
}

const UploadFileDialog = ({
  fileExists,
  fileChanged,
  acceptedFileTypes,
  setFile,
  fileChangedTitle,
  style = {},
}: IProps) => {
  const onSetFile = ({ file }) => {
    setFile(file.originFileObj);
  };

  return (
    <div style={{ width: "32px", height: "32px", ...style }}>
      {fileExists ? (
        <div>
          <Tooltip title={fileChanged ? fileChangedTitle : ""}>
            <XlsxFileIcon
              style={{
                position: "relative",
                top: "1px",
                right: "1px",
                cursor: "pointer",
                borderBottom: `solid 3px ${fileChanged ? "#00bb77" : "transparent"}`,
              }}
            />
          </Tooltip>
          <Tooltip title="Удалить файл" color="rgba(255, 0, 0, 0.7)">
            <DeleteFile
              style={{
                position: "relative",
                top: "-43px",
                right: "-21px",
                cursor: "pointer",
              }}
              onClick={() => setFile(null)}
            />
          </Tooltip>
        </div>
      ) : (
        <Upload
          action={(file) => {
            const fileType = file.type.split("/")[1];
            if (acceptedFileTypes.includes(fileType)) {
              return Promise.resolve("");
            }
            Modal.warning({ content: "Данный формат файла не поддерживается!" });
            return Promise.reject();
          }}
          customRequest={() => Promise.resolve("")}
          fileList={undefined}
          onChange={onSetFile}
          accept={acceptedFileTypes.join(", ")}
        >
          <AddFileIcon style={{ cursor: "pointer" }} />
        </Upload>
      )}
    </div>
  );
};

export default UploadFileDialog;
